import axios from "axios";

const api = axios.create({
    baseURL: "https://uaediscountedhotels.com/api",
});

export default api;